// import React from "react";

// const ChiSiamo = () => {
//   return (
//     <div className="flex flex-col items-center w-full min-h-screen bg-gradient-to-r from-white to-amber-50">
//       <p className="text-red-600 font-extrabold xs:text-2xl md:text-3xl ">
//         CHI SIAMO
//       </p>
//       <div className="w-3/4 text-center mt-8 animate__animated animate__fadeIn animate__delay-1s">
//         <p className="text-red-600 font-bold text-2xl md:text-3xl">
//           Promuoviamo la Passione per la Musica, Ispiriamo la Comunità
//         </p>
//         <p className="mt-4 text-lg md:text-xl text-gray-800">
//           Siamo lieti di presentarvi MilArte, un'Associazione di Promozione
//           Sociale dedicata alla musica. Fondata nel 2023, ci impegniamo a
//           diffondere la passione per la musica e a creare un impatto positivo
//           nella nostra comunità attraverso iniziative musicali significative.
//         </p>

//         <p className="mt-6 font-extrabold text-xl md:text-2xl text-gray-800">
//           Storia e Background:
//         </p>
//         <p className="text-lg md:text-xl text-gray-800">
//           Nata dalla visione di{" "}
//           <a
//             href="https://www.giuseppedinardo.it/"
//             className="text-red-600 hover:underline"
//             target="_blank"
//           >
//             Giuseppe Dinardo
//           </a>
//           , MilArte è stata fondata con l'obiettivo di diffondere la cultura
//           musicale. Nel corso degli anni, abbiamo consolidato la nostra presenza
//           nel panorama musicale locale grazie alla dedizione dei nostri membri e
//           al sostegno della comunità.
//         </p>

//         <p className="mt-6 font-extrabold text-xl md:text-2xl text-gray-800">
//           Obiettivi e Missioni:
//         </p>
//         <p className="text-lg md:text-xl text-gray-800">
//           Abbiamo come obiettivo proporre concerti, eventi, manifestazioni
//           varie. Crediamo che la musica possa trasformare e arricchire la vita
//           di tutti, e lavoriamo instancabilmente per rendere la musica
//           accessibile a tutti.
//         </p>

//         <p className="mt-6 font-extrabold text-xl md:text-2xl text-gray-800">
//           Attività:
//         </p>
//         <p className="text-lg md:text-xl text-gray-800">
//           Tra le nostre attività spiccano programmi e iniziative che coinvolgono
//           la comunità in esperienze musicali significative.
//         </p>

//         <p className="mt-6 font-extrabold text-xl md:text-2xl text-gray-800">
//           Membri e Struttura Organizzativa:
//         </p>
//         <p className="text-lg md:text-xl text-gray-800">
//           Il cuore pulsante di MilArte è il nostro team, guidati dal Presidente{" "}
//           <a
//             href="https://www.giuseppedinardo.it/"
//             className="text-red-600 hover:underline"
//           >
//             Giuseppe Dinardo
//           </a>
//           .
//         </p>

//         <p className="mt-6 font-extrabold text-xl md:text-2xl text-gray-800">
//           Successi e Realizzazioni:
//         </p>
//         <p className="text-lg md:text-xl text-gray-800">
//           Nello scorso dicembre 2023, abbiamo organizzato concerti, riscuotendo
//           successo e apprezzamento da parte della comunità, ma sappiamo che c'è
//           ancora molto da fare.
//         </p>

//         <p className="mt-6 font-extrabold text-xl md:text-2xl text-gray-800">
//           Partnerships e Sostenitori:
//         </p>
//         <p className="text-lg md:text-xl text-gray-800">
//           Ringraziamo i nostri preziosi partner. Senza il loro sostegno, le
//           nostre iniziative non sarebbero state possibili.
//         </p>

//         <p className="mt-6 font-extrabold text-xl md:text-2xl text-gray-800">
//           Progetti Futuri:
//         </p>
//         <p className="text-lg md:text-xl text-gray-800">
//           Per il futuro, MilArte ha in serbo diversi progetti. Siamo entusiasti
//           di continuare a crescere e di portare ancora più musica nelle vite
//           delle persone.
//         </p>

//         <p className="mt-6 font-extrabold text-xl md:text-2xl text-gray-800">
//           Come Partecipare:
//         </p>
//         <p className="text-lg md:text-xl text-gray-800">
//           Vuoi unirti a noi nel nostro viaggio musicale? Contattaci e diventa
//           parte della nostra comunità!
//         </p>

//         <p className="mt-6 font-extrabold text-xl md:text-2xl text-gray-800">
//           Contatti:
//         </p>
//         <p className="text-lg md:text-xl text-gray-800">
//           Per ulteriori informazioni, non esitate a contattarci. Seguiteci anche
//           sui social media per rimanere aggiornati sulle nostre attività.
//         </p>
//         <p className="text-red-600 mt-6 font-extrabold text-lg md:text-xl mb-5">
//           Grazie per il vostro tempo e il vostro sostegno!
//         </p>
//       </div>
//     </div>
//   );
// };

// export default ChiSiamo;

import React from "react";
import {
  FaUsers,
  FaMusic,
  FaBullseye,
  FaLightbulb,
  FaHandshake,
  FaRocket,
  FaEnvelope,
} from "react-icons/fa";
import { FaPeopleGroup } from "react-icons/fa6";

const ChiSiamo = () => {
  return (
    <div className="flex flex-col items-center w-full min-h-screen bg-gradient-to-r from-white to-amber-50 text-gray-800">
      <p className="text-red-600 font-extrabold text-3xl md:text-4xl mt-5 tracking-wide z-10">
        CHI SIAMO
      </p>
      <FaPeopleGroup className="fixed text-amber-200/40 text-[180px] rotate-12 -top-5 -right-5 z-0" />

      <div className="w-10/12 md:w-3/4 mt-10 text-center space-y-12 animate__animated animate__fadeIn mb-12 z-10">
        {/* INTRO */}
        <section>
          <p className="text-red-600 font-bold text-2xl md:text-3xl mb-4">
            Promuoviamo la Passione per la Musica, Ispiriamo la Comunità
          </p>
          <p className="text-lg md:text-xl leading-relaxed">
            Siamo lieti di presentarvi{" "}
            <span className="font-semibold">MilArte</span>, un'Associazione di
            Promozione Sociale dedicata alla musica. Fondata nel{" "}
            <strong>2023</strong>, ci impegniamo a diffondere la passione per la
            musica e a creare un impatto positivo nella nostra comunità
            attraverso iniziative musicali significative.
          </p>
        </section>

        {/* STORIA */}
        <section className="bg-white shadow-md rounded-2xl p-6 md:p-10 hover:shadow-xl transition-all duration-300">
          <FaUsers className="text-red-600 text-3xl mx-auto mb-3" />
          <h2 className="font-bold text-2xl mb-3 text-gray-900">
            Storia e Background
          </h2>
          <p className="text-lg md:text-xl leading-relaxed">
            Nata dalla visione di{" "}
            <a
              href="https://www.giuseppedinardo.it/"
              className="text-red-600 hover:underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              Giuseppe Dinardo
            </a>
            , MilArte è stata fondata per diffondere la cultura musicale. La
            nostra presenza nel panorama musicale locale cresce grazie alla
            dedizione dei nostri membri e al sostegno della comunità.
          </p>
        </section>

        {/* MISSIONE */}
        <section className="bg-gradient-to-r from-amber-100 to-white rounded-2xl p-6 md:p-10 shadow-md hover:shadow-xl transition-all duration-300">
          <FaBullseye className="text-orange-500 text-3xl mx-auto mb-3" />
          <h2 className="font-bold text-2xl mb-3 text-gray-900">
            Obiettivi e Missioni
          </h2>
          <p className="text-lg md:text-xl leading-relaxed">
            Proponiamo concerti, eventi e manifestazioni, convinti che la musica
            possa trasformare e arricchire la vita di tutti. Lavoriamo per
            rendere l’arte musicale accessibile e coinvolgente per tutti.
          </p>
        </section>

        {/* ATTIVITÀ */}
        <section className="bg-white rounded-2xl p-6 md:p-10 shadow-md hover:shadow-xl transition-all duration-300">
          <FaMusic className="text-red-600 text-3xl mx-auto mb-3" />
          <h2 className="font-bold text-2xl mb-3 text-gray-900">Attività</h2>
          <p className="text-lg md:text-xl leading-relaxed">
            Offriamo programmi, laboratori e iniziative per far vivere
            esperienze musicali autentiche alla comunità, favorendo l’incontro
            tra professionisti e appassionati.
          </p>
        </section>

        {/* MEMBRI */}
        <section className="bg-gradient-to-r from-white to-amber-100 rounded-2xl p-6 md:p-10 shadow-md hover:shadow-xl transition-all duration-300">
          <FaLightbulb className="text-yellow-500 text-3xl mx-auto mb-3" />
          <h2 className="font-bold text-2xl mb-3 text-gray-900">
            Membri e Struttura
          </h2>
          <p className="text-lg md:text-xl leading-relaxed">
            Il cuore pulsante di MilArte è il nostro team, guidato dal
            Presidente{" "}
            <a
              href="https://www.giuseppedinardo.it/"
              className="text-red-600 hover:underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              Giuseppe Dinardo
            </a>
            , che con passione e dedizione guida l’associazione verso nuovi
            traguardi.
          </p>
        </section>

        {/* SUCCESSI */}
        <section className="bg-white rounded-2xl p-6 md:p-10 shadow-md hover:shadow-xl transition-all duration-300">
          <FaHandshake className="text-green-600 text-3xl mx-auto mb-3" />
          <h2 className="font-bold text-2xl mb-3 text-gray-900">
            Successi e Realizzazioni
          </h2>
          <p className="text-lg md:text-xl leading-relaxed">
            Nel dicembre 2023 abbiamo organizzato concerti di grande successo,
            ricevendo apprezzamento dalla comunità. Ma questo è solo l’inizio!
          </p>
        </section>

        {/* PROGETTI FUTURI */}
        <section className="bg-gradient-to-r from-amber-50 to-white rounded-2xl p-6 md:p-10 shadow-md hover:shadow-xl transition-all duration-300">
          <FaRocket className="text-red-500 text-3xl mx-auto mb-3" />
          <h2 className="font-bold text-2xl mb-3 text-gray-900">
            Progetti Futuri
          </h2>
          <p className="text-lg md:text-xl leading-relaxed">
            MilArte guarda al futuro con entusiasmo: nuovi eventi,
            collaborazioni e progetti educativi per diffondere la cultura
            musicale in modo innovativo.
          </p>
        </section>

        {/* CONTATTI */}
        <section className="bg-white rounded-2xl p-6 md:p-10 shadow-md hover:shadow-xl transition-all duration-300 ">
          <FaEnvelope className="text-red-600 text-3xl mx-auto mb-3" />
          <h2 className="font-bold text-2xl mb-3 text-gray-900">Contatti</h2>
          <p className="text-lg md:text-xl leading-relaxed">
            Vuoi unirti a noi nel nostro viaggio musicale? Scrivici o seguici
            sui social per rimanere aggiornato sulle attività.
          </p>
          <p className="text-red-600 mt-6 font-extrabold text-lg md:text-xl">
            Grazie per il vostro tempo e il vostro sostegno!
          </p>
        </section>
      </div>
    </div>
  );
};

export default ChiSiamo;
